import { Component, Input, AfterViewInit, ChangeDetectionStrategy, ViewChild, ElementRef, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'nwfsal-elements-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaptchaComponent implements AfterViewInit {

  @ViewChild('reCaptcha') reCaptcha: ElementRef;
  
  @Input() key: string;
  @Input() hasError: boolean;

  @Output() verify: EventEmitter<any> = new EventEmitter<any>();

  captcha: any;
  captchaWidgetId: any;
  
  constructor(
    private _cd: ChangeDetectorRef,
  ) {
    // This runs on reCaptcha V2
    (<any> window).initCaptcha = () => {
      this.initCaptchaNG()
    }
  }

  ngAfterViewInit() {

    if (!(<any> window).document.getElementById('google-recaptcha-id')) {

      let reCaptchaScript = (<any> window).document.createElement('script');
      reCaptchaScript.id = 'google-recaptcha-id';
      reCaptchaScript.type = 'text/javascript',
      reCaptchaScript.src = 'https://www.google.com/recaptcha/api.js?onload=initCaptcha&render=explicit';
      reCaptchaScript.async = true;
      reCaptchaScript.defer = true;

      (<any> window).document.body.appendChild(reCaptchaScript);
    } else {
      this.initCaptchaNG();
    }

  }

  initCaptchaNG() {
    this.captcha = (<any> window).grecaptcha;
    if (this.captcha) {
      this.captchaWidgetId = this.captcha.render(this.reCaptcha.nativeElement, {
        'sitekey': this.key,
        'callback': (response) => this.captchaSuccess(response),
        'expired-callback': () => this.captchaExpire()
      });
    }
  }

  captchaSuccess(response) {
    if (response) {
      this.hasError = false;
      this.verify.emit(response);
    } else {
      this.hasError = true;
    }
    this._cd.detectChanges();
  }

  captchaExpire() {
    this.captcha.reset(this.captchaWidgetId);
    this.verify.emit('');
    this.hasError = true;
    this._cd.detectChanges();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/captcha/captcha.component.ts